// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__Rubik_c0aba2', '__Rubik_Fallback_c0aba2'"},"className":"__className_c0aba2"};